import { render, staticRenderFns } from "./InsuranceList.vue?vue&type=template&id=b6bb43ae&scoped=true&"
import script from "./InsuranceList.vue?vue&type=script&lang=ts&"
export * from "./InsuranceList.vue?vue&type=script&lang=ts&"
import style0 from "./InsuranceList.vue?vue&type=style&index=0&id=b6bb43ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bb43ae",
  null
  
)

export default component.exports